module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "do-table do-table__user-employments",
    class: {
      'do-table__user-employments--import': _vm.isSalaryIntegrationActive
    }
  }, [_c('thead', [_c('th', {
    staticClass: "th-check",
    attrs: {
      "title": _vm.selectedEmploymentIds.length === 0 ? _vm.$t('vue2.tagging.select_all') : _vm.$t('vue2.tagging.unselect_all')
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleAllEmployments')
      }
    }
  }, [_c('div', {
    staticClass: "check-wrapper"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "readonly": ""
    },
    domProps: {
      "checked": _vm.isAllVisibleSelected,
      "indeterminate": _vm.isIndeterminateVisible
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("CPR")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), _c('th', [_vm._v("Periode")]), _vm._v(" "), _c('th', {
    staticClass: "td-percent"
  }, [_vm._v("Beskæftigelse")]), _vm._v(" "), _c('th', [_vm._v("Organisation")]), _vm._v(" "), _c('th', [_vm._v("Stillingskategori")]), _vm._v(" "), _c('th', {
    staticClass: "td-subsalary"
  }, [_vm._v("Vikarløn")]), _vm._v(" "), _c('th', [_vm._v("Std. Lønkode")]), _vm._v(" "), _c('th', [_vm._v("Std. Omkostningsted")]), _vm._v(" "), (_vm.rowActionLabel) ? _c('th', {
    staticClass: "th-row-actions"
  }) : _vm._e()]), _vm._v(" "), _c('tbody', {
    ref: "d-b"
  }, [_vm._l((_vm.filteredUsers), function(user) {
    return (_vm.isSalaryIntegrationActive) ? [_c('tbody', {
      key: 'user-' + user.id,
      staticClass: "user-group"
    }, [_vm._l((user.v_employments), function(employment) {
      return _c('tr', {
        key: 'employment-' + employment.id
      }, [_c('td', {
        staticClass: "td-check",
        attrs: {
          "title": "Vælg/fravælg ansættelse"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$emit('toggleEmployment', employment)
          }
        }
      }, [_c('div', {
        staticClass: "check-wrapper"
      }, [_c('input', {
        attrs: {
          "type": "checkbox",
          "readonly": ""
        },
        domProps: {
          "checked": _vm.isEmploymentSelected(employment.id)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      })])]), _vm._v(" "), _c('td', {
        class: {
          'td-organisation': !_vm.hasStillingskategori(employment)
        }
      }, [_c('div', {
        staticClass: "name-cell"
      }, [_c('strong', [_vm._v(_vm._s(user.name))])])]), _vm._v(" "), _c('td', {
        staticClass: "td-ssn",
        class: {
          'td-organisation': !!user.ssn
        }
      }, [(user.ssn) ? _c('span', [_vm._v(_vm._s(_vm.formatSsn(user.ssn)))]) : _c('span', {
        staticClass: "text-link",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$emit('editSsn', user)
          }
        }
      }, [_vm._v("Indtast CPR")])]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [(_vm.isShowEmploymentNumber) ? [_vm._v(_vm._s(employment.employment_number) + " -")] : _vm._e(), _vm._v("\n        " + _vm._s(employment.source_title ? employment.source_title : employment.title) + "\n      ")], 2), _vm._v(" "), _c('td', {
        staticClass: "td-organisation td-period"
      }, [_vm._v(_vm._s(_vm.formatEmploymentPeriod(employment)))]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation td-percent"
      }, [_vm._v(_vm._s(_vm.formatEmploymentPercent(employment.employment_percent)))]), _vm._v(" "), _c('td', {
        staticClass: "td-organisation"
      }, [_vm._v(_vm._s(employment.organisation))]), _vm._v(" "), _c('td', [(_vm.hasStillingskategori(employment)) ? _c('span', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: (_vm.isStillingskategoriFromOtherSchool(employment) ? {
            arrow: true,
            animateFill: false,
            animation: 'shift-away',
            zIndex: '999999992',
            boundary: 'window'
          } : {
            trigger: 'manual'
          }),
          expression: "isStillingskategoriFromOtherSchool(employment) ? {\n                    arrow: true,\n                    animateFill: false,\n                    animation: 'shift-away',\n                    zIndex: '999999992',\n                    boundary: 'window'\n                  } : { trigger: 'manual' }"
        }],
        staticClass: "d-tag d-tag--inline",
        class: {
          'd-tag--from-other-school': _vm.isStillingskategoriFromOtherSchool(employment),
          'd-tag--inline--clickable': !_vm.isStillingskategoriFromOtherSchool(employment)
        },
        attrs: {
          "content": _vm.isStillingskategoriFromOtherSchool(employment) ? 'Kommer fra anden skole' : null
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.onStillingskategoriClick(user, employment)
          }
        }
      }, [_vm._v("\n              " + _vm._s(employment.title) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "td-subsalary"
      }, [(_vm.showEmploymentSalaryFields(employment)) ? _c('span', {
        staticClass: "do-pill do-pill--small do-custom-pill do-pill--yellow"
      }, [_vm._v("Vikarløn\n          ")]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.showEmploymentSalaryFields(employment)) ? _c('span', {
        staticClass: "do-pill do-pill--small do-custom-pill do-pill--multiline"
      }, [_vm._v("\n          " + _vm._s(_vm.getDefaultSalaryCodeName(employment.salary_code_id)) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.showEmploymentSalaryFields(employment) && employment.default_omkostningssted) ? _c('span', {
        staticClass: "do-pill do-pill--small do-custom-pill do-pill--multiline"
      }, [_vm._v("\n          " + _vm._s(_vm.getCostCenterName(employment.default_omkostningssted)) + "\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.rowActionLabel) ? _c('td', {
        staticClass: "td-row-actions"
      }, [_c('div', {
        staticClass: "row-action-btns"
      }, [_c('button', {
        staticClass: "row-action-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$emit('removeEmployment', {
              user: user,
              employment: employment
            })
          }
        }
      }, [_vm._v("Fjern ansættelse")]), _vm._v(" "), (user.ssn) ? _c('button', {
        staticClass: "row-action-btn",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.setTheEditUser(user)
          }
        }
      }, [_vm._v("Opret ny ansættelse")]) : _vm._e()])]) : _vm._e()])
    }), _vm._v(" "), (user.v_employments.length === 0) ? _c('tr', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setTheEditUser(user)
        }
      }
    }, [_c('td', {
      staticClass: "td-check"
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "name-cell"
    }, [_c('b', [_vm._v(_vm._s(user.name))])])]), _vm._v(" "), _c('td', {
      staticClass: "td-ssn",
      class: {
        'td-organisation': !!user.ssn
      }
    }, [(user.ssn) ? _c('span', [_vm._v(_vm._s(_vm.formatSsn(user.ssn)))]) : _c('span', {
      staticClass: "text-link",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit('editSsn', user)
        }
      }
    }, [_vm._v("Indtast CPR")])]), _vm._v(" "), _c('td', [(_vm.rowActionLabel && user.ssn) ? _c('span', {
      staticClass: "text-link",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setTheEditUser(user)
        }
      }
    }, [_vm._v(_vm._s(_vm.rowActionLabel))]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "td-percent"
    }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "td-subsalary"
    }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.rowActionLabel) ? _c('td', {
      staticClass: "td-row-actions"
    }) : _vm._e()]) : _vm._e()], 2)] : _vm._l((_vm.filteredUsers), function(user) {
      return _c('tr', {
        key: user.id
      }, [_c('td', {
        attrs: {
          "colspan": "1"
        }
      }), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
        staticClass: "d-tags",
        attrs: {
          "colspan": "6"
        }
      }, [_vm._l((user.v_employments), function(employment) {
        return _c('div', {
          key: employment.id,
          staticClass: "d-tag",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.$emit('toggleEmployment', employment)
            }
          }
        }, [_c('input', {
          staticClass: "td-check__inline",
          attrs: {
            "type": "checkbox",
            "readonly": ""
          },
          domProps: {
            "checked": _vm.isEmploymentSelected(employment.id)
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }), _vm._v("\n          " + _vm._s(employment.title) + "\n          "), (employment.organisation) ? _c('div', {
          staticClass: "d-tag d-tag--inner"
        }, [_vm._v(_vm._s(employment.organisation))]) : _vm._e(), _vm._v(" "), (employment.manual_salary) ? _c('div', {
          staticClass: "do-pill do-pill--small do-pill--yellow"
        }, [_vm._v("Vikarløn")]) : _vm._e()])
      }), _vm._v(" "), (user.v_employments.length === 0 && _vm.isShowNoEmploymentsText) ? _c('p', {
        staticClass: "italic font-small"
      }, [_vm._v("Ingen\n          ansættelser")]) : _vm._e()], 2)])
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-674316b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalarySettingsUsersOpusTable.vue
// module id = 1975
// module chunks = 1